var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEducationalContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.41667 16.6666H4.16667C3.24619 16.6666 2.5 15.9204 2.5 15V3.33329C2.5 2.41282 3.24619 1.66663 4.16667 1.66663H15.8333C16.7538 1.66663 17.5 2.41282 17.5 3.33329V15C17.5 15.9204 16.7538 16.6666 15.8333 16.6666H14.5833M10 15.8333C11.3807 15.8333 12.5 14.714 12.5 13.3333C12.5 11.9526 11.3807 10.8333 10 10.8333C8.61929 10.8333 7.5 11.9526 7.5 13.3333C7.5 14.714 8.61929 15.8333 10 15.8333ZM10 15.8333L10.0179 15.8331L7.35723 18.4938L5.0002 16.1367L7.51638 13.6206M10 15.8333L12.6607 18.4938L15.0177 16.1367L12.5015 13.6206M7.5 4.99996H12.5M5.83333 7.91663H14.1667",
    stroke: "#7E5AE2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationalContent);
export default __webpack_public_path__ + "static/media/educational_content.4c2daa8b44787d2e08bc23da201a3b43.svg";
export { ForwardRef as ReactComponent };